/** @format */

export const debug = require('debug')('http');
export const actionDebug = require('debug')('actions');
export const reducerDebug = require('debug')('reducers');
export const componentDebug = require('debug')('components');
export const queueDebug = require('debug')('queues');
export const cacheDebug = require('debug')('cache');
